import { render } from "./AdmModal.vue?vue&type=template&id=58c0c0d0&scoped=true"
import script from "./AdmModal.vue?vue&type=script&lang=js"
export * from "./AdmModal.vue?vue&type=script&lang=js"

import "./AdmModal.vue?vue&type=style&index=0&id=58c0c0d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c0c0d0"]])

export default __exports__